module.exports = __webpack_public_path__ + "img/check.65dd72bc.svg";